import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { Utils } from "Utils/utils";
import { customListState } from "Pages/Dashboard/dataSearch/CustomList/state";
import MultiSelectDropdownWithInput from "Components/common/MultiSelectDropDownWithInput";
import { PreviewTags } from "Components/common/tags/PreviewTags";

const AddList = observer(props => {
  const {
    selectedLists = [],
    setSelectedLists = () => { },
    dropdownWidth = "",
    type = ""
  } = props;
  const [listData, setListData] = useState([]);
  const [showListDropDown, setShowListDropDown] = useState(false);
  const [previewLists, setPreviewLists] = useState([]);
  const [resetInputVal, setInputResetVal] = useState(0)

  const findSelectedLists = (allLists, selectedIds) => {
    if (!allLists || !selectedIds) return [];
    return allLists.filter(list => selectedIds.includes(list.id));
  };

  const updateListDataCheckedStatus = (allLists, selectedIds) => {
    if (!allLists) return [];
    const updatedLists = allLists
      .filter(list => list?.name !== "All")
      .map(list => ({
        ...list,
        value: list.name,
        checked: selectedIds?.includes(list.id) || false
      }));
    return updatedLists;
  };

  const handleSetOptions = (updatedOptions) => {
    const selectedIds = updatedOptions
      .filter(opt => opt.checked)
      .map(opt => opt.id);

    setSelectedLists(selectedIds);
  };

  const handleAddNewOption = async (value) => {
    const res = await customListState.createContactList(value);
    const listResponse = res?.data?.listResponse;
    if (res?.data?.statusCode === 200 && listResponse?.statusCode === 200) {
      const newListId = listResponse.list?.[0]?.id;
      if (newListId) {
        setSelectedLists([...(selectedLists || []), newListId]);
        setInputResetVal(prev => prev + 1);
        setShowListDropDown(false);
      }
    }
  };

  const handleCreateList = (value) => {
    handleAddNewOption(value);
  };

  useEffect(() => {
    customListState.getContactList();
  }, []);

  useEffect(() => {
    if (customListState.totalContactList) {
      const updatedLists = updateListDataCheckedStatus(
        customListState.totalContactList,
        selectedLists || []
      );
      setListData(updatedLists);
      setPreviewLists(findSelectedLists(customListState.totalContactList, selectedLists || []));
    }
  }, [customListState.totalContactList, selectedLists]);

  const removeList = (listId) => {
    const updatedIds = (selectedLists || []).filter(id => id !== listId);
    setSelectedLists(updatedIds);
  };

  return (
    <div className="addTagsWrapper sectionMarginBottom" style={{ position: "relative", zIndex: showListDropDown ? 5 : 1 }}>
      <div className="flexColumn">
        <span className="headingText">Add to List</span>
        <span className="headingSubText">
          {`Add all imported ${type === "LEADS" ? "leads" : "contacts"
            } from CRM to selected lists`}
        </span>
      </div>
      <div className="info contactTags">
        <div className="parentWrapper" style={{ gridTemplateColumns: `${dropdownWidth}px auto` }}>
          <div className="sectionInputTagsCont">
            <MultiSelectDropdownWithInput
              key={resetInputVal}
              label={"Select List"}
              options={listData}
              setOptions={handleSetOptions}
              showOptions={showListDropDown}
              setShowOptions={setShowListDropDown}
              onAddOption={handleCreateList}
              fromCrmAddList={true}
            />
          </div>
          {selectedLists?.length > 0 && (
            <div className="previewTagWrapper">
              <PreviewTags
                selectedTags={previewLists.map(l => ({ id: l.id, value: l.name }))}
                removeTag={removeList}
              />
            </div>
          )}
        </div>
      </div>
      {showListDropDown && (
        <div
          className="transparentOverlay"
          onClick={e => setShowListDropDown(false)}
        ></div>
      )}
    </div>
  );
});

export { AddList };
export default AddList;